module.exports = __webpack_public_path__ + "static/media/music.8a26544c.svg";